const tabConfig = {
    tabs: [
        {
            id: '1',
            radio: 'radio-2',
            intent: 'PromptEmbeddings',
            label: 'tabDocuments',
            icon: 'description',
            accessKey: 'DocumentsAccess',
                        dropdownItems: []
        },
        {
            id: '2',
            radio: 'radio-3',
            intent: 'PromptGpt',
            label: 'tabChat',
            icon: 'contact_support',
            accessKey: 'ChatAccess',
            dropdownItems: [
                { id: 0, name: "GPT-6.1 Terra" },   // config.json OpenAI_mini (gpt-6.1-terra)
                { id: 1, name: "GPT-6.1 Sol" }      // config.json OpenAI (gpt-6.1-sol)
                        ]
        }
    ]
};

export default tabConfig;